import { render, staticRenderFns } from "./FormFotoEdit.vue?vue&type=template&id=f05dde5a"
import script from "./FormFotoEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./FormFotoEdit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports